import type { DataTableColumnSettingsTriggerProps } from './column-settings-types.js';

/**
 * The slot component for specifying the custom label to be displayed in the column settings trigger
 * @public
 */
export const DataTableColumnSettingsTrigger = ({
  children,
}: DataTableColumnSettingsTriggerProps) => null;

DataTableColumnSettingsTrigger.displayName = 'DataTable.ColumnSettingsTrigger';
